<template>
    <page
      :empty="!galleries.length > 0"
      empty-text="Leider gibt es derzeit keine Galerie zu sehen.">
        <div class="gallery-wrap">
            <div class="gallery">
                <Lightbox
                  v-for="(content, index) in galleryContent"
                  :key="index"
                  :index="index"
                  :type="content.type"
                  :content="content"></Lightbox>
            </div>
        </div>
    </page>
</template>

<script type="text/babel">
import Lightbox, { LightboxTypes } from '../Lighbox/index.vue';
import Page from '../Page.vue';

export default {
  name: 'Gallery',
  components: {
    Lightbox,
    Page,
  },
  data() {
    return {};
  },
  computed: {
    galleries() {
      return this.$store.getters.getGalleries.filter((gallery) => (
        !this.$config.galleries || this.$config.galleries.find((gal) => gal === gallery.id)
      ));
    },
    galleryContent() {
      return this.galleries.reduce((accumulator, currentValue) => (
        [...accumulator, ...[
          ...currentValue.images.map((img) => ({
            ...img,
            type: LightboxTypes.img,
          })),
          ...currentValue.videos.map((vid) => ({
            ...vid,
            type: LightboxTypes.Video,
          })),
        ]]
      ), []).filter(({ id }, index, self) => self.findIndex((itm) => itm.id === id) === index);
    },
  },
};
</script>

<style lang="scss">
    .gallery {
        --column-count: 4;
        @media screen and (max-width: 100em) {
            --column-count: 3;
        }
        @media screen and (max-width: 65em) {
            --column-count: 2;
        }
        column-count: var(--column-count);
        column-gap: 0.5em;
        column-fill: balance;
        display: block;
        height: auto;
        width: 100%;
        &-wrap {
            padding: .5em;
            overflow: auto;
        }
    }
</style>
